import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IAlertMessage } from './alert-messages.interface';

export const selectAlertMessages = createFeatureSelector<IAlertMessage[]>('alertMessages');

export const getAlertMessages = createSelector(
    selectAlertMessages,
    (alertMessages: IAlertMessage[]) => alertMessages
);
